import {
  Component,
  OnInit,
  Input,
  AfterContentInit,
  AfterViewInit,
  OnDestroy,
  ComponentFactoryResolver
} from '@angular/core';
import {EmbedVideoService} from 'ngx-embed-video';
import * as Player from '@vimeo/player/dist/player.js';
import {InteractionsService} from 'src/app/services/interactions.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})
export class VideoComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input('content') content;
  @Input('interaction') interaction;

  public video_embed;
  private interactionsSubscriber;
  public localStorage = localStorage;

  constructor(
    private activatedRoute: ActivatedRoute,
    private embedService: EmbedVideoService,
    private interactionsService: InteractionsService
  ) {
    console.log('content', this.content);
    console.log('interaction', this.interaction);
  }

  ngOnInit(): void {
    if (this.content) {
      this.video_embed = this.embedService.embed(this.content.videoUrl, {
        query: {playsinline: 0, rel: 0}
      });
    } else {
      this.interactionsSubscriber = this.interactionsService.interactions$.subscribe(interactions => {
        console.log(interactions);
        console.log(this.activatedRoute.snapshot.params);
        if (interactions) {
          this.interaction = interactions.find(interaction => interaction.url == this.activatedRoute.snapshot.params.slug);
          console.log('interaction', this.interaction);
          this.content = this.interaction.content;
          this.video_embed = this.embedService.embed(this.content.videoUrl, {
            query: {playsinline: 0}
          });
        }
      });
    }
  }

  ngAfterViewInit() {
    const iframe = document.querySelector('iframe');
    if (iframe) {
      const player = new Player(iframe);
      player.on('play', event => {
        console.log('played the video!');
      });
      player.on('pause', event => {
        console.log('paused the video at' + event.percent + '%');
      });
      player.on('ended', event => {
        console.log('congrats!! You have seen the full video');
        if (this.interaction) {
          this.interaction.completed = {
            onComplete: true,
            status: 'success'
          };
          this.interactionsService.updateInteraction(this.interaction);
          this.interactionsService.setCompleted(this.interaction);
        }
      });
    }


    /* player.on('play', function (event) {
      console.log('played the video!');
    });

    this.player.on('ended', function () {
      console.log('Finished.');
    }); */

  }

  ngOnDestroy() {
    if (this.interactionsSubscriber) {
      this.interactionsSubscriber.unsubscribe();
    }
  }

}
